// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { IContextualMenuItem } from '@fluentui/react';
import { _DrawerMenuItemProps } from '@internal/react-components';

/**
 * Convert IContextualMenuItem to _DrawerMenuItemProps
 * @param contextualMenu - IContextualMenuItem to convert
 * @param onDrawerMenuItemClick - callback to call when converted DrawerMenuItem is clicked
 * @returns DrawerMenuItem
 * @private
 */
export const convertContextualMenuItemToDrawerMenuItem = (contextualMenu: IContextualMenuItem, onDrawerMenuItemClick: () => void): _DrawerMenuItemProps => {
  return {
    itemKey: contextualMenu.key,
    onItemClick: () => {
      contextualMenu.onClick?.();
      onDrawerMenuItemClick();
    },
    iconProps: contextualMenu.iconProps,
    text: contextualMenu.text,
    disabled: contextualMenu.disabled
  };
};